<script setup lang="ts">
import type { CmsElementSeoTextWithFourRows } from "~/composables/useCustom";
const props = defineProps<{
  content: CmsElementSeoTextWithFourRows;
}>();

const seoData = props.content?.data || {};
</script>

<template v-if="seoData">
  <div class="seo px-4">
    <div class="container mx-auto relative py-14 sm:py-24">
      <div class="wrap">
        <!-- Section title -->
        <div class="mb-12 text-center">
          <div class="title">
            <h3 class="h3-font mb-12" v-if="seoData.headlineText">
              {{ seoData.headlineText }}
            </h3>
          </div>
        </div>

        <template v-for="(row, index) in seoData.Rows" :key="index">
          <div
            :class="[
              'flex justify-between items-center flex-wrap md:flex-nowrap',
              index % 2 === 0 && row.rowImageRight?.media ? 'flex-col-reverse md:flex-row' : 'flex-col-reverse md:flex-row-reverse',
              index === seoData.Rows.length - 1 ? 'mb-0' : 'mb-12 md:mb-0',
            ]"
          >
            <!-- Text Content -->
            <div
              class="w-full md:w-3/5 lg:w-[712px] mb-0 md:mb-8 lg:mb-0 pr-0 md:pr-2.5"
              v-html="row.rowText"
            ></div>

            <!-- Image Content -->
            <div class="w-full md:w-2/5 lg:w-[488px] mb-4">
              <NuxtImg
                v-if="row.rowImageRight?.media"
                :format="row.rowImageRight?.media.mimetype"
                :src="row.rowImageRight?.media.url"
                class="w-full h-auto"
                :alt="row.rowImageRight?.media.alt"
                loading="lazy"
                :width="row.rowImageRight?.media.metaData?.width ? row.rowImageRight?.media.metaData?.width : 488"
                :height="row.rowImageRight?.media.metaData?.height ? row.rowImageRight?.media.metaData?.height : 320"
              />
              <NuxtImg
                v-else-if="row.rowImageLeft?.media"
                format="webp"
                :src="row.rowImageLeft?.media.url"
                class="w-full h-auto"
                :alt="row.rowImageLeft?.media.alt"
                loading="lazy"
                :width="row.rowImageLeft?.media.metaData?.width ? row.rowImageLeft?.media.metaData?.width : 488"
                :height="row.rowImageLeft?.media.metaData?.height ? row.rowImageLeft?.media.metaData?.height : 320"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
